var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk238430(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87.7 30",
    style: {
      enableBackground: "new 0 0 87.7 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 7,
    transform: "matrix(0.8828 -0.4697 0.4697 0.8828 -1.5933 8.7398)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 -10.2107 25.0368)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.7,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3,30H0.2V0h30.1V30z M1.3,28.8h27.8V1.2H1.3V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3,25.9H3.6V3.7h22.8V25.9z M4.7,24.8h20.4V4.8H4.7V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.9,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 5.1567 35.7579)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 18.6168 74.8158)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7,30H57.6V0h30.1V30z M58.7,28.8h27.8V1.2H58.7V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7,25.9H61V3.7h22.8V25.9z M62.1,24.8h20.4V4.8H62.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 7,
    transform: "matrix(0.8828 -0.4697 0.4697 0.8828 1.7696 22.2192)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.6,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 4.2029 49.9262)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,30H28.9V0H59V30z M30,28.8h27.8V1.2H30V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,25.9H32.3V3.7H55V25.9z M33.4,24.8h20.4V4.8H33.4V24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3,30c-0.2,0-0.4-0.1-0.5-0.3l-1.4-3.3c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l1.4,3.3c0.1,0.3,0,0.6-0.3,0.8 L29.3,30z M26.8,24.3c-0.2,0-0.4-0.1-0.5-0.3l-1.4-3.3c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l1.4,3.3 c0.1,0.3,0,0.6-0.3,0.8L26.8,24.3z M24.2,18.5c-0.2,0-0.4-0.1-0.5-0.3l-1.4-3.3c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3 l1.4,3.3c0.1,0.3,0,0.6-0.3,0.8L24.2,18.5z M21.7,12.8c-0.2,0-0.4-0.1-0.5-0.3l-1.4-3.3c-0.1-0.3,0-0.6,0.3-0.8 c0.3-0.1,0.6,0,0.8,0.3l1.4,3.3c0.1,0.3,0,0.6-0.3,0.8L21.7,12.8z M19.2,7.1c-0.2,0-0.4-0.1-0.5-0.3l-1.4-3.3 c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l1.4,3.3c0.1,0.3,0,0.6-0.3,0.8L19.2,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6,30l-0.3-0.1c-0.3-0.2-0.4-0.5-0.2-0.8L1.8,26c0.2-0.3,0.5-0.4,0.8-0.2C2.9,26,3,26.3,2.8,26.6l-1.8,3.1 C1,29.9,0.8,30,0.6,30z M3.7,24.5l-0.3-0.1C3.1,24.3,3,24,3.2,23.7l1.8-3.1c0.2-0.3,0.5-0.4,0.8-0.2c0.3,0.2,0.4,0.5,0.2,0.8 l-1.8,3.1C4.1,24.4,3.9,24.5,3.7,24.5z M6.7,19.1L6.5,19c-0.3-0.2-0.4-0.5-0.2-0.8L8,15.1c0.2-0.3,0.5-0.4,0.8-0.2 c0.3,0.2,0.4,0.5,0.2,0.8l-1.8,3.1C7.1,19,6.9,19.1,6.7,19.1z M9.8,13.6l-0.3-0.1c-0.3-0.2-0.4-0.5-0.2-0.8l1.8-3.1 c0.2-0.3,0.5-0.4,0.8-0.2c0.3,0.2,0.4,0.5,0.2,0.8l-1.8,3.1C10.2,13.5,10,13.6,9.8,13.6z M12.9,8.2l-0.3-0.1 c-0.3-0.2-0.4-0.5-0.2-0.8l1.8-3.1C14.3,3.9,14.7,3.8,15,4c0.3,0.2,0.4,0.5,0.2,0.8l-1.8,3.1C13.3,8.1,13.1,8.2,12.9,8.2z M16,2.7 l-0.3-0.1c-0.3-0.2-0.4-0.5-0.2-0.8l0.7-1.3c0.2-0.3,0.5-0.4,0.8-0.2c0.3,0.2,0.4,0.5,0.2,0.8l-0.7,1.3C16.4,2.6,16.2,2.7,16,2.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk238430);
export default __webpack_public_path__ + "static/media/AK2_3_843_0.3e29bfd8ffe335c4d5e7b3ff5ff1994a.svg";
export { ForwardRef as ReactComponent };